<template>
  <base-template current-page="SettingsIndex">
    <router-view></router-view>
  </base-template>
</template>

<script>
import BaseTemplate from "../BaseTemplate";

export default {
  name: "SettingsIndex",
  components: { BaseTemplate },
};
</script>
